import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SEO from 'utils/seo';

import ThumbGrid from 'components/molecules/thumbGrid';
import MetaGrid from 'components/molecules/metaGrid';
import ProjectVideo from 'components/molecules/projectVideo';

import Loader from 'components/atoms/svgLoader';

import { loaderIn, loaderOut, fadeIn } from 'components/utils/animation';
import './style.css';

class Project extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animated: false
        };
    }

    componentDidMount() {
        if (this.props.hasLoaded) {
            this.loaderNode.style.display = 'none';
            fadeIn(this.contentNode);
            this.setState({
                animated: true
            });
        } else {
            loaderIn(this.loaderNode);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.hasLoaded &&
            !this.props.isLoading &&
            !this.state.animated
        ) {
            loaderOut(this.loaderNode).finished.then(() => {
                fadeIn(this.contentNode);
            });

            this.setState({
                animated: true
            });
        }
    }

    render() {
        const {
            title,
            path,
            vimeoURL,
            coverURL,
            coverTitle,
            stills,
            metaData,
            hasLoaded
        } = this.props;
        const hasData = title !== '' ? true : false;
        const seoTitle = `${title}`;

        let seoDescription = '';

        metaData.forEach(item => {
            // if (item.value !== ' - ') {
            seoDescription = `${seoDescription}${item.title}: ${item.value} / `;
            // }
        });

        return (
            <div className="Project">
                {hasData && (
                    <SEO
                        schema="Website"
                        title={seoTitle}
                        description={seoDescription}
                        path={path}
                        image={coverURL}
                        hasLoaded={hasLoaded}
                    />
                )}
                <div
                    className="Project__loader"
                    ref={div => {
                        this.loaderNode = div;
                    }}
                >
                    <Loader />
                </div>
                <div
                    className="Project__content"
                    ref={div => {
                        this.contentNode = div;
                    }}
                >
                    <div className="Project__content__video">
                        <ProjectVideo
                            title={title}
                            url={vimeoURL}
                            cover={coverURL}
                            coverTitle={coverTitle}
                        />
                    </div>
                    <div className="Project__content__text">
                        <h2 className="Project__content__title">{title}</h2>
                        <div className="Project__content__meta">
                            <MetaGrid items={metaData} />
                        </div>
                        <div className="Project__content__stills">
                            <ThumbGrid items={stills} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Project.propTypes = {
    title: PropTypes.string,
    vimeoURL: PropTypes.string,
    coverURL: PropTypes.string,
    stills: PropTypes.array,
    metaData: PropTypes.array,
    isLoading: PropTypes.bool
};

Project.defaultProps = {
    title: 'Project page',
    vimeoURL: '',
    coverURL: '',
    metaData: [],
    stills: [],
    isLoading: true
};

export default Project;



// WEBPACK FOOTER //
// ./src/components/organisms/project/index.js